export default {
    ACTIVE: 0,
    PAUSE: 1,
    STOP: 2,
    PENDING: 3,
    REJECTED: 4,

    // To Manage Processes
    ADD_COMMISSIONS: 5,
    ADD_PROMOTIONS: 6,
    ADD_PRODUCTS: 7,

    TERMINATED: 8,
}